<template>
  <div>
    <v-skeleton-loader
      v-if="isDropped"
      class="mx-auto"
      type="card"
    ></v-skeleton-loader>
    <v-card
      v-if="!isDropped"
      ref="documentCard"
      v-click-outside="onClickOutside"
      :draggable="isDraggable"
      class="d-flex flex-column"
      height="100%"
      @click="onClickInside"
      @dblclick="goToDocument"
      @contextmenu.prevent="showContextualMenu"
      @dragstart="onDragStart"
      @dragover="onDragEnter"
      @dragenter="onDragEnter"
      @dragleave="onDragLeave"
    >
      <v-card-title>
        <v-row>
          <v-col
            class="d-flex align-center"
            cols="10"
          >
            <v-icon left>
              mdi-folder
            </v-icon>
            <h6>
              {{ documentObj.title }}
            </h6>
          </v-col>
          <v-col
            class="d-flex justify-end"
            cols="2"
          >
            <group-documents-menu
              v-if="isOwner"
              :show-menu="isShow.contextualMenu"
              @closeMenu="closeContextualMenu"
              @clickEdit="isShow.edit = true"
              @clickDelete="isShow.delete = true"
            />
          </v-col>
        </v-row>
      </v-card-title>

      <edit-group-document
        is-plugin-version
        no-auto-import
        :is-show="isShow.edit"
        :document-data="documentObj"
        @close="isShow.edit=false"
        @reload-data="reloadData"
      />
      <destroy-group-document
        is-plugin-version
        :is-show="isShow.delete"
        :document-data="documentObj"
        @close="isShow.delete=false"
        @reload-data="reloadData"
      />
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import vClickOutside from 'v-click-outside'
import EditGroupDocument from '@/components/modals/edit-group-document.vue'
import DestroyGroupDocument from '@/components/modals/delete-group-document.vue'
import GroupDocumentsMenu from '@/components/menus/group-documents-menu.vue'

export default {
  name: 'GroupDocumentsCard',
  components: {
    GroupDocumentsMenu,
    EditGroupDocument,
    DestroyGroupDocument,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    documentObj: {
      type: Object,
      required: true,
    },
    documentRoute: {
      type: String,
      default: 'groupDocumentFiles',
    },
    isPluginVersion: {
      type: Boolean,
      default: false,
    },
    isDraggable: {
      type: Boolean,
      default: false,
    },
    isDropped: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShow: {
        edit: false,
        delete: false,
        contextualMenu: false,
      },
    }
  },
  computed: {
    ...mapGetters(['loggedUser']),
    isOwner() {
      return this.loggedUser?.company_role === 'owner'
    },
  },
  methods: {
    cardElement() {
      return this.$refs.documentCard?.$el || this.$refs.documentCard
    },
    onDragEnter(e) {
      e.preventDefault()
      this.cardElement()?.classList.add('selectedFolder')
    },
    onDragLeave(e) {
      e.preventDefault()
      this.cardElement()?.classList.remove('selectedFolder')
    },
    onClickInside() {
      this.cardElement()?.classList.add('selectedFolder')
    },
    onClickOutside() {
      this.cardElement()?.classList.remove('selectedFolder')
      this.closeContextualMenu()
    },
    goToDocument() {
      this.$router.push({
        name: this.documentRoute,
        params: { did: this.documentObj.id },
      })
    },
    onDragStart(ev) {
      ev.dataTransfer.setData('documentId', this.documentObj.id)
      ev.dataTransfer.setData('groupId', this.documentObj.group_id)
    },
    async reloadData() {
      await this.$emit('reload-data')
    },
    closeContextualMenu() {
      this.isShow.contextualMenu = false
    },
    showContextualMenu(e) {
      e.preventDefault()
      this.isShow.contextualMenu = true
    },
  },
}
</script>

<style scoped>
.v-card {
  user-select: none;
}

.selectedFolder {
  background-color: #c2e7ff !important;
}
</style>
